module.exports = __webpack_public_path__ + "static/img/nodata@2x.e4b8619b.png";